<template lang="html">
  <div class="apply">
    <div class="messageCon">
      <div class="particulars">
        <div class="formMod">
          <div class="formTitle">
            <img src="../../assets/image/icon/form.png" alt="" class="formNum">
            <p>姓名</p>
            <img src="../../assets/image/icon/must.png" alt="" class="must">
          </div>
          <input type="text" placeholder="请输入姓名" class="messageInput" v-model="userName" :maxlength="10">
        </div>

        <div class="formMod">
          <div class="formTitle">
            <img src="../../assets/image/icon/form.png" alt="" class="formNum">
            <p>公司</p>
            <img src="../../assets/image/icon/must.png" alt="" class="must">
          </div>
          <input type="text" placeholder="请输入公司名称" class="messageInput" v-model="userCompany" :maxlength="50">
        </div>

        <div class="formMod">
          <div class="formTitle">
            <img src="../../assets/image/icon/form.png" alt="" class="formNum">
            <p>职业类别<span>（至少选择1个）</span></p>
            <img src="../../assets/image/icon/must.png" alt="" class="must">
          </div>
          <div class="categorysList">
            <div v-for="(x, index) in skillData" :key="x.id" class="categorys" :class="x.class" @click="getIndex(x.id, index)">
              {{x.name}}
            </div>
          </div>
        </div>

        <div class="submitBtn" v-if="appApplyShow" @click="appSubmitBtn(backfillArr)">
          {{submitText}}
        </div>
        <div class="submitBtn" v-else @click="elseSubmitBtn()">
          {{submitText}}
        </div>
      </div>
    </div>

    <div class="tooltipMod" v-show="tooltipShow">
      <div class="tooltipCon">
        <img src="../../assets/image/icon/success.png" alt="">
        <p>提交成功</p>
        <div>
          立即看直播
          <WxOpenTag :extinfo="'live/detail?url=' + this.activityUrl" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import utils from '@/utils/utils.js';
  import Cookies from 'js-cookie';
  import {
    Base64
  } from '@/utils/base64.js';
  import {
    pagehost
  } from '@/utils/http.js';
  import WxOpenTag from '@/components/WxOpenTag';

  // var Ua = navigator.userAgent;
  var name = /^[\u4e00-\u9fa5a-zA-Z]{2,10}$/;
  var company = /^[\u4e00-\u9fa5a-zA-Z]{2,50}$/;

  export default {
    data() {
      return {
        userInfo: {},
        appApplyShow: false,
        userName: '',
        userCompany: '',
        skillData: [],
        categorysArr: [],
        backfillArr: [],
        laberlArr: [],
        submitText: '提交',
        joinStatus: this.$route.query.join_status,
        succeedShow: false,
        jumpTarget: '',
        activityUrl: '',
        tooltipShow: false,
        channelType: this.$route.query.channel,
        projectId: '',
      }
    },

    components: {
      WxOpenTag,
    },

    created() {
      window.setUserInfo = this.setUserInfo;
      utils.communicateToNative('getUserInfo', {
        success: "setUserInfo"
      });
    },

    computed: {
      nextEnabled() {
        return this.userName && this.userCompany
      },
    },

    mounted() {
      this.init()
    },

    methods: {
      init() {
        document.title = '填写报名信息';
        this.callAppMedia();
        this.getSkillList();
        if (this.joinStatus == 0) {
          this.submitText = '提交后查看直播'
        }
        // this.appApplyShow = Ua.search("app_elecnest") != -1
      },

      setUserInfo(info) {
        info && (this.userInfo = JSON.parse(Base64.decode(info)));
        this.appOpen();
        this.appApplyShow = true;
      },

      // 微信回填信息
      wxOpen() {
        this.$http({
          url: '/activity/getRegisterInfo',
          method: 'get',
          params: {
            uid: Cookies.get('uid'),
            token: Cookies.get('token'),
            reg_channel: 'pc',
          },
        }).then((res) => {
          if (res.code >= 0) {
            this.userName = res.data.name;
            this.userCompany = res.data.company;
            this.categorysArr = res.data.skill_ids;
            for (var i = 0; i < this.categorysArr.length; i++) {
              for (var a = 0; a < this.skillData.length; a++) {
                if (this.categorysArr[i] == this.skillData[a].id) {
                  this.skillData[a]['class'] = 'active';
                }
              }
            }
          }
        })
      },

      // APP
      appOpen() {
        this.$http({
          url: '/activity/getRegisterInfo',
          method: 'get',
          params: {
            uid: this.userInfo.uid,
            token: this.userInfo.token,
          },
        }).then((res) => {
          if (res.code >= 0) {
            this.userName = res.data.name;
            this.userCompany = res.data.company;
            this.categorysArr = res.data.skill_ids;
            this.backfillArr = res.data.skill_ids;
            for (var i = 0; i < this.categorysArr.length; i++) {
              for (var a = 0; a < this.skillData.length; a++) {
                if (this.categorysArr[i] == this.skillData[a].id) {
                  this.skillData[a]['class'] = 'active';
                }
              }
            }
          }
        })
      },

      callAppMedia() {
        this.$http({
          url: '/activity/detail',
          method: 'get',
          params: {
            activity_id: this.$route.query.id,
          },
        }).then((res) => {
          if (res.code >= 0) {
            this.activityUrl = res.data.live_url;
            this.projectId = res.data.project_id;
          }
        })
      },

      getSkillList() {
        this.$http('/index/categorys', {
          method: 'get',
          params: {
            all: 1,
            is_edu: 0,
            group_id: 3,
          }
        }).then(res => {
          if (res.code >= 0) {
            this.skillData = res.data.slice(1);
            for (var i = 0; i < this.skillData.length; i++) {
              this.$set(this.skillData[i], 'class', ' ')
              
              this.laberlArr.push(this.skillData[i].id)
            }
            
            if(!utils.browserChecker.isElecnest()){
              this.wxOpen();
            }
          }
        })
      },

      getIndex(index, e) {
        if (this.categorysArr.indexOf(index) !== -1) {
          this.categorysArr.splice(this.categorysArr.indexOf(index), 1);
          this.skillData[e]['class'] = 'false';
        } else {
          this.backfillArr = this.laberlArr.filter(item => this.categorysArr.includes(item));
          
          this.backfillArr.push(index)
          
          this.categorysArr.push(index);
          this.skillData[e]['class'] = 'active';
        }
      },

      appSubmitBtn() {
        this.categorysArr = [...this.backfillArr];

        if(name.test(this.userName) && this.userName) {
          if(company.test(this.userCompany) && this.userCompany) {
            if (this.backfillArr != false) {
              this.$http({
                url: '/activity/activityRegister',
                method: 'post',
                params: {
                  name: this.userName,
                  company: this.userCompany,
                  skill_ids: this.backfillArr.join(','),
                  activity_id: this.$route.query.id,
                  uid: this.userInfo.uid,
                  token: this.userInfo.token,
                  channel: this.channelType,
                  project_id: this.projectId,
                }
              }).then((res) => {
                if (res.code >= 0) {
                  if (res.data.need_pay == 0) {
                    this.$router.push({
                      path: '/succeed',
                      query: {
                        id: this.$route.query.id,
                        name: this.userName,
                        channel: this.channelType,
                        type_id: this.$route.query.type_id
                      }
                    });
                  } else if (res.data.need_pay == 1) {
                    window.location.href = pagehost + '/html/common/payment.html?hideNativeNav=1&sn=' + res.data.order_sn + '&snType=activity&activity_id=' + this.$route.query.id;
                  }
                } else {
                  utils.communicateToNative('showAlertString', {
                    alert: res.msg
                  });
                }
              })
            } else {
              utils.communicateToNative('showAlertString', {
                alert: '请选择您的技术方向，至少一个'
              });
            }
          } else {
            utils.communicateToNative('showAlertString', {
              alert: '请输入2-50个文字的公司名'
            });
          }
        } else {
          utils.communicateToNative('showAlertString', {
            alert: '请输入2-10个文字的姓名'
          });
        }
      },

      elseSubmitBtn() {
        this.backfillArr = [...this.backfillArr]
        
        if (this.joinStatus == 0) {
          if(name.test(this.userName) && this.userName) {
            if(company.test(this.userCompany) && this.userCompany) {
              if (this.categorysArr != false) {
                this.$http({
                  url: '/activity/activityRegister',
                  method: 'post',
                  params: {
                    name: this.userName,
                    company: this.userCompany,
                    skill_ids: this.backfillArr.join(','),
                    activity_id: this.$route.query.id,
                    uid: Cookies.get('uid'),
                    token: Cookies.get('token'),
                    reg_channel: 'pc',
                    channel: this.channelType,
                    project_id: this.projectId,
                  }
                }).then((res) => {
                  if (res.code == '0') {
                    this.tooltipShow = true;
                  } else {
                    utils.showMessage(res.msg)
                  }
                })
              } else {
                utils.showMessage('请选择您的技术方向，至少一个')
              }
            } else {
              utils.showMessage('请输入2-50个文字的公司名')
            }
          } else {
            utils.showMessage('请输入2-10个文字的姓名')
          }
        } else {
          // 验证姓名为2-10个汉字
          if(name.test(this.userName) && this.userName) {
            if(company.test(this.userCompany) && this.userCompany) {
              if (this.categorysArr != false) {
                this.$http({
                  url: '/activity/activityRegister',
                  method: 'post',
                  params: {
                    name: this.userName,
                    company: this.userCompany,
                    skill_ids: this.backfillArr.join(','),
                    activity_id: this.$route.query.id,
                    uid: Cookies.get('uid'),
                    token: Cookies.get('token'),
                    reg_channel: 'pc',
                    channel: this.channelType,
                    project_id: this.projectId,
                  }
                }).then((res) => {
                  if (res.code == '0') {
                    this.$router.replace({
                      path: '/succeed',
                      query: {
                        id: this.$route.query.id,
                        name: this.userName,
                        type_id: this.$route.query.type_id,
                        channel: this.channelType, 
                      }
                    });
                  } else {
                    utils.showMessage(res.msg)
                  }
                })
              } else {
                utils.showMessage('请选择您的技术方向，至少一个')
              }
            } else {
              utils.showMessage('请输入2-50个文字的公司名')
            }
          } else {
            utils.showMessage('请输入2-10个文字的姓名')
          }
        }
      },
    }
  }
</script>

<style lang="css" scoped>
  .apply {}

  .messageCon {
    width: 100%;
    background-color: #FFF;
    overflow: auto;
  }

  .particulars {
    box-sizing: border-box;
    padding: 1.5rem 1.5rem 0 1.5rem;
  }

  .formMod {
    margin-bottom: 2rem;
  }

  .formTitle {
    display: flex;
    align-items: center;
    font-size: 1.6rem;
    font-weight: 600;
  }

  .formTitle span {
    color: #A5A5A6;
    font-weight: 400;
  }

  .formNum {
    height: 1.3rem;
    margin-right: .55rem;
  }

  .must {
    height: .95rem;
    margin-left: .3rem;
  }

  .messageInput {
    border: none;
    outline: none;
    width: 100%;
    height: 4.2rem;
    box-sizing: border-box;
    padding: 1.4rem 1.6rem;
    font-size: 1.4rem;
    margin-top: 1.15rem;
    background-color: #F8F9FB;
  }

  .categorysList {
    margin-top: 1.5rem;
  }

  .categorys {
    box-sizing: border-box;
    display: inline-block;
    height: 3.5rem;
    background-color: #F8F9FB;
    padding: .8rem 2.5rem;
    border-radius: 3.5rem;
    margin-right: 1.3rem;
    margin-bottom: 1rem;
    color: #333333;
    font-size: 1.4rem;
  }

  .active {
    background-color: #F7443F;
    color: #fff;
  }

  .submitBtn {
    position: relative;
    width: 100%;
    height: 4.5rem;
    line-height: 4.5rem;
    text-align: center;
    border-radius: 4.5rem;
    background-color: #F7443F;
    font-size: 1.6rem;
    color: #FFF;
  }

  /* 提示框 */
  .tooltipMod {
    box-sizing: border-box;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6000);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0 3.5rem;
  }

  .tooltipCon {
    width: 100%;
    height: 25rem;
    background-color: #FFF;
    border-radius: 1.5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .tooltipCon img {
    width: 5.8rem;
    height: 5.8rem;
    margin-top: 5.3rem;
  }

  .tooltipCon p {
    margin-top: .5rem;
    font-size: 1.5rem;
    font-weight: 600;
  }

  .tooltipCon div {
    position: relative;
    width: 17.65rem;
    height: 4.4rem;
    line-height: 4.4rem;
    border-radius: 4.4rem;
    text-align: center;
    background-color: #F7443F;
    color: #FFF;
    margin-top: 2.5rem;
  }
</style>
